<template>
    <ErrorLayout>
        <span class="title">401</span>
        <span class="title second second-without-text-transform">{{ __('Unauthorized Access') }}</span>
        <span class="description">{{ __('Please try logging in again to access this resource') }}</span>
        <router-link
            to="/"
            exact=""
            class="button"
        >
            <div class="button-content">
                <img
                    src="@/assets/images/angle-icon.svg"
                    alt=""
                >
                <span class="button-title">{{ __('Go Back') }}</span>
            </div>
        </router-link>
    </ErrorLayout>
</template>

<script>
    import ErrorLayout from '@/components/pages/ErrorLayout'

    export default {
        components: { ErrorLayout },
    }
</script>


